import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShareWith = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.133 10.672a2.121 2.121 0 1 0 0-4.243 2.121 2.121 0 0 0 0 4.243m0 1.5a3.621 3.621 0 1 0 0-7.243 3.621 3.621 0 0 0 0 7.243"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M8.133 12.922c-2.81 0-4.883 1.93-4.883 4.078a.75.75 0 1 1-1.5 0c0-3.185 2.97-5.578 6.383-5.578s6.384 2.393 6.384 5.578a.75.75 0 1 1-1.5 0c0-2.148-2.074-4.078-4.884-4.078M11.75 5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15 1.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShareWith;
